var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('div',{staticClass:"container"},[_vm._l((_vm.results),function(row){return _c('div',{key:row.id,staticClass:"row"},[_vm._v(_vm._s(row))])}),_c('button',{on:{"click":_vm.loadData}},[_vm._v("Recarregar")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }